export interface SubscriptionFeature
{
	Name: string;
    PropertyKey: string;
    SubscriptionPlanId: number;
    AccessGranted: boolean;
    NumericalLimit: number;
    TimePeriodMonths: number;
    IconPublicId: string;
    UpdatedByUserId: string;
    DateUpdatedUtc: Date;
}

export class CreateSubscriptionFeature
{
    Key: string;
    PlanId: number;
    IconPublicId: string;
    AccessGranted: boolean;
    NumericalLimit: number;
    TimePeriodMonths: number;
    UpdatedByUserId: string;
    DateUpdatedUtc: Date;
}

export class UpdateSubscriptionFeature extends CreateSubscriptionFeature
{
    SubscriptionPlanId: number;
    PropertyKey: string;
    constructor(item?: SubscriptionFeature) {
        super();
        this.SubscriptionPlanId = item.SubscriptionPlanId;
        this.PropertyKey = item.PropertyKey;
        this.IconPublicId = item.IconPublicId;
        this.NumericalLimit = item.NumericalLimit;
        this.TimePeriodMonths = item.TimePeriodMonths;
        this.AccessGranted = item.AccessGranted;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/SubscriptionFeatures.ts